export enum ShareholderShareReportType {
    PURCHASE = 'PURCHASE',
    SALE = 'SALE'
}
